import type { EventMapV3 } from '@makemydeal/dr-common-data-layer-utils';
import { buildUserEventV3 } from '@makemydeal/dr-common-data-layer-utils';
import { CHANGE_VEHICLE_CLICKED, UPDATE_CUSTOM_VEHICLE } from '@makemydeal/dr-activities-change-vehicle';

import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import {
    COMMON_CONSUMER_UPDATE_VALIDATION_STATE,
    OPEN_DEAL,
    TOGGLE_CHANGE_VEHICLE_EDIT_VIEW
} from '../actionTypes/openDealActionTypes';
import type { CdlEventInfo } from '../types/cdl';

const buildEventWrapper = (eventData: CdlEventInfo) => (_action: AnyFSA) => {
    return buildUserEventV3(eventData);
};

export const openDealCdlEvents: EventMapV3 = {
    [OPEN_DEAL]: buildEventWrapper({
        action: 'Click',
        element: 'Open Deal Button',
        location: ['Deal Dashboard Lite'],
        intention: 'Open Deal with Updated Information',
        tagIndex: 'dc-mv-159'
    }),
    [CHANGE_VEHICLE_CLICKED]: (action: AnyFSA) => {
        // AVO applies are Manager View-only and already carry the Vehicle-Search vs-024 tag; this Open-Deal
        // (Deal Dashboard Lite) dc-mv-158 must not also fire for them.
        if (action.payload?.selectedVehicle?.recommendedPayment || action.meta?.addNewScenario) {
            return { event: {} };
        }
        return buildUserEventV3({
            action: 'Click',
            element: 'Select Vehicle Button',
            location: ['Deal Dashboard Lite'],
            intention: 'Select Vehicle from Search List',
            tagIndex: 'dc-mv-158'
        });
    },
    [UPDATE_CUSTOM_VEHICLE]: (action: AnyFSA) => {
        const payload = action.payload;
        const hasAnyValue =
            payload && typeof payload === 'object' && Object.values(payload).some((value) => value !== undefined && value !== null);
        if (!hasAnyValue) return { event: {} };
        return buildUserEventV3({
            action: 'Update',
            element: 'Update Vehicle Information Text Input Field',
            location: ['Deal Dashboard Lite'],
            intention: 'Update Missing Vehicle Information',
            tagIndex: 'dc-mv-157'
        });
    },

    [COMMON_CONSUMER_UPDATE_VALIDATION_STATE]: (action: any, _currentState: any) => {
        const isValidCustomerCardState = action.payload?.isConsumerValid;
        if (isValidCustomerCardState) {
            return buildEventWrapper({
                action: 'Update',
                element: 'Customer Card Input Fields',
                location: ['Deal Dashboard Lite'],
                intention: 'Update Customer Card Input Fields',
                tagIndex: 'dc-mv-156'
            })(action);
        }
        return { event: {} };
    },
    [TOGGLE_CHANGE_VEHICLE_EDIT_VIEW]: (action: any, currentState: any) => {
        const isChangeVehicleEditView = currentState.openDeal?.isChangeVehicleEditView;
        return buildEventWrapper({
            action: 'Click',
            element: isChangeVehicleEditView ? 'Edit Vehicle Selection Link' : 'Close Vehicle Selection Link',
            location: ['Deal Dashboard Lite'],
            intention: isChangeVehicleEditView ? 'Edit Vehicle Selection' : 'Exit Vehicle Selection',
            tagIndex: 'dc-mv-180'
        })(action);
    }
};
